import one from "../../../../assets/logos/1.svg";
import two from "../../../../assets/logos/2.svg";
import three from "../../../../assets/logos/3.svg";
import four from "../../../../assets/logos/4.svg";
import five from "../../../../assets/logos/5.svg";
import six from "../../../../assets/logos/6.svg";
import seven from "../../../../assets/logos/7.svg";
import eight from "../../../../assets/logos/8.svg";

export const clientLogos = [
  { icon: one },
  { icon: two },
  { icon: three },
  { icon: four },
  { icon: five },
  { icon: six },
  { icon: seven },
  { icon: eight },
];
